import React from 'react'
import { useHistory } from 'react-router-dom'
import { Icon, Popup } from 'semantic-ui-react'
import { navigateToProductAliasRemap } from '../../../utils/navigate'

export const AliasRemapButton = ({
  productId,
  aliasId,
}: {
  productId: string | number
  aliasId: string | number
}) => {
  const history = useHistory()
  const navigateOpts = { productId, aliasId, returnUrl: history.location.pathname }
  return (
    <Popup
      content="Remap alias"
      trigger={
        <Icon
          link
          bordered
          name="arrow right"
          onClick={() => navigateToProductAliasRemap(navigateOpts)}
        />
      }
    />
  )
}
